import { useQuery } from "@tanstack/react-query";

import { getSessionsQueryOptions } from "services/chatbotService/queries";

export default function useFetchAmeliaSessions(options?: {
  lastKey?: string;
  limit?: number;
  enabled?: boolean;
}) {
  return useQuery({
    ...getSessionsQueryOptions(options)
  });
}
